/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {File} from '../file.entity';
import {BlockElement, BlockElementSettings} from './blockElement';
import {
  AppColorList, AppIconsList,
  BlockElementIconSizeList,
  BlockElementType,
  BlockIconPositionList,
  BlockIconVerticalAlignmentList,
  BlockSettingsAlignmentList
} from '../enums';
import {BlockAction} from './blockAction';

export class BlockElementIcon extends BlockElement {
  type?: BlockElementType = 'icon';

  icon?: AppIconsList = null;
  image?: File = null;

  @Type(() => BlockElementIconSettings)
  settings?: BlockElementIconSettings = new BlockElementIconSettings();

  @Type(() => BlockAction)
  action?: BlockAction = null;
}

export class BlockElementIconSettings extends BlockElementSettings {
  size?: BlockElementIconSizeList = 'small';
  color?: AppColorList = 'secondary';
  position?: BlockIconPositionList = 'before';
  alignment?: BlockSettingsAlignmentList = 'left';
  verticalAlignment?: BlockIconVerticalAlignmentList = 'center';
}
